export default {
  login: {
    txt1: "In-game Secret Code Verification",
    txt2: "Enter the secret code...",
    txt3: "Verify",
    txt4: "Please select your server...",
    txt5: "Please select your UID...",
    txt6: "Login",
    txt7: "Help Center",
    txt8: "Invalid Code"
  },
  nav: {
    txt1: "Home",
    txt2: "Live Stream",
    txt3: "Leaderboard",
    txt4: "Tournament\nMVP",
    txt5: "Spectate",
    txt6: "Live Stream\nGiveaways",
    txt7: "Rewards",
    txt8: "Content\nCreator Project",
  },
  live: {
    txt1: "Matches",
    txt2: "More Live Streams",
    txt3: "Time：",
    txt4: "Content：",
    txt5: "Enter",
    txt6: "Time",
    txt7: "Match",
    txt8: "Please Login",
  },
  process: {
    nav1: "Qualification Matches Ranking",
    nav2: "Roadmap of Elimination Matches",
    nav3: "Leaderboard",
    txt1: "Rank",
    txt2: "Team Name",
    txt3: "Server",
    txt4: "Points",
    txt5: "Division",
    txt6: "Kills",
    list: ["Division Ⅰ", "Division Ⅱ", "Division Ⅲ", "Division Ⅳ"],
    img: require("@/assets/en-img.jpg"),
  },
  periphery: {
    time1: "2023/11/22",
    title1: "Giveaway #1: Semifinals Gift Code l",
    time2: "2023/11/24",
    title2: "Giveaway #2: Semifinals Gift Code ll",
    time3: "2023/11/25",
    title3: "Giveaway #3: Championship Gift Code",
    p1: "Wager Token",
    p2: "Diamond ",
    p3: "Guild Token Chest ",
    p4: "Large Zeny Chest ",
    p5: "Rare Card Coupon ",
    p6: "Refining & Enchanting Pack II",
  },
  mvp: {
    txt1: "Personal Best",
    txt2: "Server",
    txt3: "Team Name",
    txt4: "IGN",
    txt5: "Level",
    txt6: "Job",
    txt7: "Top 32 Elimination",
    txt8: "Offline Finals",
  },
  task: {
    loginTip: "Adventurers! Log in and complete quests to receive rewards!",
    reward830: "Delot Opt. Pack *10\nNebula Path Material *50",
    task830: "Watch matches for <span>10 min</span> on 9/30",
    reward91: "Ash of Delot *300\n Nebula Path Material *50",
    task91: "Watch matches for <span>10 min</span> on 10/2",
    reward92: "Precious Sigil Pack *5\n Nebula Path Material *100",
    task92: "Watch matches for <span>10 min</span> on 10/4",
    reward94: "Time-Space Sacred Feather *15\nLight-Dark Sacred Feather *15",
    task94: "Watch matches for <span>15 min</span> on 10/9",
    reward96: "Time-Space Sacred Feather *15\nLight-Dark Sacred Feather *15",
    task96: "Watch matches for <span>15 min</span> on 10/11",
    reward98:
      "Type-D Module Box *3 Type-C Module Box *5\nDiamond *500",
    task98: "Watch matches for <span>15 min</span> on 10/13",
    rewardTotal2: "Enchanting Coin Opt. Chest *5\nEden Pouch (L) *15",
    taskTotal2: "Complete 3 Viewing Quests",
    rewardTotal5: "Gold Card Coupon *10 Gacha Ticket *10\nSuper Pet Coupon *10",
    taskTotal5: "Complete 6 Viewing Quests",
    txt7: "Progress",
    txt8: "In Progress",
    txt9: "Details",
    txt10: "Claim",
    txt11: "已领取11",
  },
  reward: [
    {
      type: "Elimination Matches",
      item: [
        {
          name: "1st Place",
          image: require("@/assets/lna/re1.png"),
          imageM: require("@/assets/lna/mobile/re1.png"),
          list: [
            {
              name: "Thor Cup Champion Mount",
              amount: "",
            },
            {
              name: "Title: Thor Cup Champion (2024)",
              amount: "",
            },
            {
              name: "Chat Bubble: Thor Cup Champion",
              amount: "",
            },
            {
              name: "Portrait Frame: Thor Cup Champion",
              amount: "",
            },
            {
              name: "Champion Banner",
              amount: "20",
            },
            {
              name: "Nyan Berry",
              amount: "20000",
            },
            {
              name: "Diamond",
              amount: "5000",
            },
            {
              name: "Optional Orange Sigil",
              amount: "10",
            },
            {
              name: "Opt. Statue Box (D)",
              amount: "30",
            },
            {
              name: "Light-Dark Opt. Chest",
              amount: "40",
            },
            {
              name: "Crest of Moon",
              amount: "5",
            },
            {
              name: "King Statue Chest",
              amount: "10",
            },
          ],
        },
        {
          name: "2nd Place",
          image: require("@/assets/lna/re2.png"),
          imageM: require("@/assets/lna/mobile/re2.png"),
          list: [
            {
              name: "Title: Thor Cup 2nd Place (2024)",
              amount: "",
            },
            {
              name: "Chat Bubble: Thor Cup 2nd Place",
              amount: "",
            },
            {
              name: "Portrait Frame: Thor Cup Runner-up",
              amount: "",
            },
            {
              name: "Champion Banner",
              amount: "20",
            },
            {
              name: "Nyan Berry",
              amount: "10000",
            },
            {
              name: "Diamond",
              amount: "4500",
            },
            {
              name: "Optional Orange Sigil",
              amount: "10",
            },
            {
              name: "Opt. Statue Box (D)",
              amount: "25",
            },
            {
              name: "Light-Dark Opt. Chest",
              amount: "36",
            },
            {
              name: "Crest of Moon",
              amount: "4",
            },
            {
              name: "King Statue Chest",
              amount: "8",
            },
          ],
        },
        {
          name: "3rd & 4th\nPlace",
          image: require("@/assets/lna/re3.png"),
          imageM: require("@/assets/lna/mobile/re3.png"),
          list: [
            {
              name: "Title: Thor Cup Top 4 (2024)",
              amount: "",
            },
            {
              name: "Chat Bubble: Thor Cup Top 4",
              amount: "",
            },
            {
              name: "Portrait Frame: Thor Cup Top 4",
              amount: "",
            },
            {
              name: "Champion Banner",
              amount: "17",
            },
            {
              name: "Nyan Berry",
              amount: "5000",
            },
            {
              name: "Diamond",
              amount: "4000",
            },
            {
              name: "Optional Orange Sigil",
              amount: "8",
            },
            {
              name: "Opt. Statue Box (D)",
              amount: "20",
            },
            {
              name: "Light-Dark Opt. Chest",
              amount: "32",
            },
            {
              name: "Crest of Moon",
              amount: "3",
            },
            {
              name: "King Statue Chest",
              amount: "6",
            },
          ],
        },
        {
          name: "5th - 8th\nPlace",
          image: require("@/assets/lna/re4.png"),
          imageM: require("@/assets/lna/mobile/re4.png"),
          list: [
            {
              name: "Title: Thor Cup Top 8 (2024)",
              amount: "",
            },
            {
              name: "Chat Bubble: Thor Cup Top 8",
              amount: "",
            },
            {
              name: "Portrait Frame: Thor Cup Top 8",
              amount: "",
            },
            {
              name: "Champion Banner",
              amount: "15",
            },
            {
              name: "Nyan Berry",
              amount: "3000",
            },
            {
              name: "Diamond",
              amount: "3000",
            },
            {
              name: "Optional Orange Sigil",
              amount: "6",
            },
            {
              name: "Opt. Statue Box (D)",
              amount: "15",
            },
            {
              name: "Light-Dark Opt. Chest",
              amount: "28",
            },
            {
              name: "Crest of Moon",
              amount: "2",
            },
            {
              name: "King Statue Chest",
              amount: "4",
            },
          ],
        },
        {
          name: "9th - 16th\nPlace",
          image: require("@/assets/lna/re5.png"),
          imageM: require("@/assets/lna/mobile/re5.png"),
          list: [
            {
              name: "Title: Thor Cup Top 16 (2024)",
              amount: "",
            },
            {
              name: "Chat Bubble: Thor Cup Top 32",
              amount: "",
            },
            {
              name: "Portrait Frame: Thor Cup Top 32",
              amount: "",
            },
            {
              name: "Champion Banner",
              amount: "7",
            },
            {
              name: "Nyan Berry",
              amount: "2000",
            },
            {
              name: "Diamond",
              amount: "2000",
            },
            {
              name: "Optional Orange Sigil",
              amount: "4",
            },
            {
              name: "Opt. Statue Box (D)",
              amount: "10",
            },
            {
              name: "Light-Dark Opt. Chest",
              amount: "24",
            },
            {
              name: "Crest of Moon",
              amount: "2",
            },
            {
              name: "King Statue Chest",
              amount: "2",
            },
          ],
        },
        {
          name: "17th - 32nd\nPlace",
          image: require("@/assets/lna/re6.png"),
          imageM: require("@/assets/lna/mobile/re6.png"),
          list: [
            {
              name: "Title: Thor Cup Top 32 (2024)",
              amount: "",
            },
            {
              name: "Chat Bubble: Thor Cup Top 32",
              amount: "",
            },
            {
              name: "Portrait Frame: Thor Cup Top 32",
              amount: "",
            },
            {
              name: "Champion Banner",
              amount: "5",
            },
            {
              name: "Nyan Berry",
              amount: "1500",
            },
            {
              name: "Diamond",
              amount: "1500",
            },
            {
              name: "Optional Orange Sigil",
              amount: "2",
            },
            {
              name: "Opt. Statue Box (D)",
              amount: "5",
            },
            {
              name: "Light-Dark Opt. Chest",
              amount: "20",
            },
            {
              name: "Crest of Moon",
              amount: "1",
            },
          ],
        },
      ],
    },
    {
      type: "Qualification Matches",
      item: [
        {
          name: "Rank\n #1~4",
          image: require("@/assets/lna/re7.png"),
          imageM: require("@/assets/lna/mobile/re7.png"),
          list: [
            {
              name: "Title: Thor Cup Elite",
              amount: "",
            },
            {
              name: "Chat Bubble: Thor Cup Elite",
              amount: "",
            },
            {
              name: "Portrait Frame: Thor Cup Elite",
              amount: "",
            },
            {
              name: "Champion Banner",
              amount: "40",
            },
            {
              name: "Nyan Berry",
              amount: "2500",
            },
            {
              name: "Diamond",
              amount: "2500",
            },
            {
              name: "Optional Orange Sigil",
              amount: "3",
            },
            {
              name: "Opt. Statue Box (D)",
              amount: "30",
            },
            {
              name: "Light-Dark Opt. Chest",
              amount: "30",
            },
            {
              name: "Time-Space Opt. Chest",
              amount: "50",
            },
            {
              name: "Portrait: Thor Cup Elite",
              amount: "",
            }
          ],
        },
        {
          name: "Rank\n #5~8",
          image: require("@/assets/lna/re7.png"),
          imageM: require("@/assets/lna/mobile/re7.png"),
          list: [
            {
              name: "Title: Thor Cup Elite",
              amount: "",
            },
            {
              name: "Chat Bubble: Thor Cup Elite",
              amount: "",
            },
            {
              name: "Portrait Frame: Thor Cup Elite",
              amount: "",
            },
            {
              name: "Champion Banner",
              amount: "35",
            },
            {
              name: "Nyan Berry",
              amount: "2300",
            },
            {
              name: "Diamond",
              amount: "2300",
            },
            {
              name: "Optional Orange Sigil",
              amount: "3",
            },
            {
              name: "Opt. Statue Box (D)",
              amount: "25",
            },
            {
              name: "Light-Dark Opt. Chest",
              amount: "25",
            },
            {
              name: "Time-Space Opt. Chest",
              amount: "45",
            },
            {
              name: "Portrait: Thor Cup Elite",
              amount: "",
            },
          ],
        },
        {
          name: "Rank\n #9~16",
          image: require("@/assets/lna/re7.png"),
          imageM: require("@/assets/lna/mobile/re7.png"),
          list: [
            {
              name: "Title: Thor Cup Elite",
              amount: "",
            },
            {
              name: "Chat Bubble: Thor Cup Elite",
              amount: "",
            },
            {
              name: "Portrait Frame: Thor Cup Elite",
              amount: "",
            },
            {
              name: "Champion Banner",
              amount: "33",
            },
            {
              name: "Nyan Berry",
              amount: "2000",
            },
            {
              name: "Diamond",
              amount: "2000",
            },
            {
              name: "Optional Orange Sigil",
              amount: "3",
            },
            {
              name: "Opt. Statue Box (D)",
              amount: "20",
            },
            {
              name: "Light-Dark Opt. Chest",
              amount: "20",
            },
            {
              name: "Time-Space Opt. Chest",
              amount: "40",
            },
            {
              name: "Portrait: Thor Cup Elite",
              amount: "",
            },
          ],
        },
        {
          name: "Rank\n #17~32",
          image: require("@/assets/lna/re7.png"),
          imageM: require("@/assets/lna/mobile/re7.png"),
          list: [
            {
              name: "Title: Thor Cup Elite",
              amount: "",
            },
            {
              name: "Chat Bubble: Thor Cup Elite",
              amount: "",
            },
            {
              name: "Portrait Frame: Thor Cup Elite",
              amount: "",
            },
            {
              name: "Champion Banner",
              amount: "30",
            },
            {
              name: "Nyan Berry",
              amount: "1900",
            },
            {
              name: "Diamond",
              amount: "1900",
            },
            {
              name: "Optional Orange Sigil",
              amount: "3",
            },
            {
              name: "Opt. Statue Box (D)",
              amount: "15",
            },
            {
              name: "Light-Dark Opt. Chest",
              amount: "19",
            },
            {
              name: "Time-Space Opt. Chest",
              amount: "38",
            },
            {
              name: "Portrait: Thor Cup Elite",
              amount: "",
            },
          ],
        },
        {
          name: "Particpation",
          image: require("@/assets/lna/re7.png"),
          imageM: require("@/assets/lna/mobile/re7.png"),
          list: [
            {
              name: "Title: Thor Cup Elite",
              amount: "",
            },
            {
              name: "Chat Bubble: Thor Cup Elite",
              amount: "",
            },
            {
              name: "Portrait Frame: Thor Cup Elite",
              amount: "",
            },
            {
              name: "Champion Banner",
              amount: "28",
            },
            {
              name: "Nyan Berry",
              amount: "1800",
            },
            {
              name: "Diamond",
              amount: "1800",
            },
            {
              name: "Optional Orange Sigil",
              amount: "2",
            },
            {
              name: "Opt. Statue Box (D)",
              amount: "10",
            },
            {
              name: "Light-Dark Opt. Chest",
              amount: "18",
            },
            {
              name: "Time-Space Opt. Chest",
              amount: "36",
            },
            {
              name: "Portrait: Thor Cup Elite",
              amount: "",
            },
          ],
        },
        {
          name: "Match\n Rewards",
          image: require("@/assets/lna/re8.png"),
          imageM: require("@/assets/lna/mobile/re8.png"),
          list: [
            {
              name: "Diamond",
              amount: "100",
            },
            {
              name: "Mark of Prowess",
              amount: "200",
            },
            {
              name: "Random Rare Sigil Gift Box",
              amount: "1",
            },
            {
              name: "Time-Space Opt. Chest",
              amount: "5",
            },
            {
              name: "Super Cookie",
              amount: "5",
            },
            {
              name: "Purple Feather Opt. Box",
              amount: "10",
            },
          ],
        },
      ],
    },
  ],
  dia: {
    txt1: "Gift Code",
    txt2: "Copy",
    txt3: "Copy successfully",
  },
};
